<template>
	<div>
		<span class="go-index" @click="gotoPage()">返回</span>


		<img src="www.symeet.xyz/qrcode/meet2048-1.jpg" style="width: 100%;" />


		<div @click="jump('/seting/feedback')" class="check_btn">意见反馈</div>

		<!-- 组件声明 -->
		<syalert ref="syalert_id" />
	</div>
</template>
<script>
	// 组件引入
	import syalert from '@/components/syalert.vue';

	export default {
		// 组件注册
		components: {
			syalert,
		},
		data() {
			return {}
		},
		methods: {
			gotoPage: function(page) {
				if (page !== undefined) {
					this.$router.push(page);
				} else {
					this.$router.go(-1);
				}
			},
			syalert_tip: function(msg) {
				// 组件调用
				this.$refs.syalert_id.syalert(msg);
			},
		},
		mounted() {
			// http.get(this.$root.API + '/User/UserCenter').then(rtn => {
			//     this.userInfo = rtn.data;
			//     console.log(rtn);
			// });
		}
	}
</script>
<style>
	.check_btn
	{
		width: 4rem;
		padding: 1rem 2rem;
		margin: 2rem auto;
		background-color: rgb(41, 189, 84);
		color: white;

		border: 0;
	}
</style>